import { resolveDeployWeb3dPath } from '@trimble/utilities';

export function getDeployWeb3dPath(): string {
  return resolveDeployWeb3dPath(
    import.meta.env.VITE_WEB3D_PATH,
    import.meta.env.BASE_URL
  );
}
